import metamaskLogo from '../../images/full-metamask-logo.png'

const Login = ({ ethereumButton }) => {
    return (
        <div className="flex justify-center items-center my-60">
            <button onClick={ethereumButton} className=" flex relative bg-white text-blue-500 h-50 text-4xl px-12 py-6  rounded-full shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 ">
                <span className="absolute top-0 left-0 right-0 text-center text-gray-500 pl-10 text-base">Connect now with</span>
                <img className="h-28 mx-auto mb-4" src={metamaskLogo} alt="Button Image" />
            </button>
        </div>
    );
}

export default Login;